import { apiClient } from './api';
import type {
  TenantAthleteDevelopmentResponse,
  TenantDevelopmentOverviewResponse,
  TenantDrill,
  TenantDrillPayload,
  TenantLessonPlan,
  TenantLessonPlanPayload,
  TenantStudentAssignment,
  TenantStudentAssignmentPayload,
  TenantStudentAssignmentUpdatePayload,
  TenantStudentGoal,
  TenantStudentGoalPayload,
  TenantStudentGoalUpdatePayload,
} from '../types';

export async function getTenantDevelopmentOverview(): Promise<TenantDevelopmentOverviewResponse> {
  const response = await apiClient.get<TenantDevelopmentOverviewResponse>('/api/v1/web/coach-development/overview');
  return response.data;
}

export async function getTenantAthleteDevelopment(athleteId: number): Promise<TenantAthleteDevelopmentResponse> {
  const response = await apiClient.get<TenantAthleteDevelopmentResponse>(`/api/v1/web/coach-development/athletes/${athleteId}`);
  return response.data;
}

export async function createTenantDrill(payload: TenantDrillPayload): Promise<TenantDrill> {
  const response = await apiClient.post<TenantDrill>('/api/v1/web/coach-development/drills', payload);
  return response.data;
}

export async function updateTenantDrill(drillId: number, payload: TenantDrillPayload): Promise<TenantDrill> {
  const response = await apiClient.put<TenantDrill>(`/api/v1/web/coach-development/drills/${drillId}`, payload);
  return response.data;
}

export async function createTenantLessonPlan(payload: TenantLessonPlanPayload): Promise<TenantLessonPlan> {
  const response = await apiClient.post<TenantLessonPlan>('/api/v1/web/coach-development/lesson-plans', payload);
  return response.data;
}

export async function updateTenantLessonPlan(lessonPlanId: number, payload: TenantLessonPlanPayload): Promise<TenantLessonPlan> {
  const response = await apiClient.put<TenantLessonPlan>(`/api/v1/web/coach-development/lesson-plans/${lessonPlanId}`, payload);
  return response.data;
}

export async function createTenantStudentAssignment(
  payload: TenantStudentAssignmentPayload
): Promise<TenantStudentAssignment> {
  const response = await apiClient.post<TenantStudentAssignment>('/api/v1/web/coach-development/assignments', payload);
  return response.data;
}

export async function updateTenantStudentAssignment(
  assignmentId: number,
  payload: TenantStudentAssignmentUpdatePayload
): Promise<TenantStudentAssignment> {
  const response = await apiClient.patch<TenantStudentAssignment>(
    `/api/v1/web/coach-development/assignments/${assignmentId}`,
    payload
  );
  return response.data;
}

export async function createTenantStudentGoal(payload: TenantStudentGoalPayload): Promise<TenantStudentGoal> {
  const response = await apiClient.post<TenantStudentGoal>('/api/v1/web/coach-development/goals', payload);
  return response.data;
}

export async function updateTenantStudentGoal(
  goalId: number,
  payload: TenantStudentGoalUpdatePayload
): Promise<TenantStudentGoal> {
  const response = await apiClient.patch<TenantStudentGoal>(`/api/v1/web/coach-development/goals/${goalId}`, payload);
  return response.data;
}
